import { useEffect } from "react";
import { IndeterminateLoader } from "@hopper-b2b/ui";
import { Grid, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import "./styles.scss";

type FlightShopTransitionLoaderProps = {
  resetRenderLoader: () => void;
};

export const FlightShopTransitionLoader = ({
  resetRenderLoader,
}: FlightShopTransitionLoaderProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => resetRenderLoader(), 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flight-shop-loading-mobile uber">
      <IndeterminateLoader />
      {Array.from({ length: 16 }).map((_, i) => (
        <div
          className="flight-list-item-skeleton mobile"
          key={`flight-list-item-skeleton-${i}`}
        >
          <Grid item xs>
            <Typography>
              <Skeleton variant="text" width={80} />
            </Typography>
            <Typography>
              <Skeleton variant="text" width={100} />
            </Typography>
          </Grid>
          <Grid item xs style={{ flexGrow: 0 }}>
            <Typography>
              <Skeleton variant="text" width={80} />
            </Typography>
            <Typography>
              <Skeleton variant="text" width={64} />
            </Typography>
          </Grid>
        </div>
      ))}
    </div>
  );
};
